import useSelf from "./useSelf";

export const useIsAdmin = () => {
  const user = useSelf();

  return user && user.role === "rti-admin";
};
